import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/Brennan_and_Grant_Save_the_Date.mp4")